import { combineReducers } from "@reduxjs/toolkit";

import authApi from "store/api/auth";
import brandApi from "store/api/brand";
import categoryApi from "store/api/category";
import clubApi from "store/api/club";
import filterAPI from "store/api/common";
import blogApi from "store/api/content";
import dashboardApi from "store/api/dashboard";
import emailTemplatesApi from "store/api/emailTemplates";
import fourvenuesApi from "store/api/fourvenues";
import managePromotionApi from "store/api/managePromotion";
import masterApi from "store/api/master";
import profileApi from "store/api/profile";
import reportsApi from "store/api/reports";
import roleApi from "store/api/role";
import settingsApi from "store/api/settings";
import supportApi from "store/api/support";
import userApi from "store/api/users";
import userTokenReducer from "store/reducers/token";
import uiReducer from "store/reducers/ui";

import permissionsReducer from "./permissions";
/** ***************** 
@purpose : root reducer
@Author : INIC
@return : combine reducers
***************** */

export default () =>
  combineReducers({
    ui: uiReducer,
    token: userTokenReducer,
    permissions: permissionsReducer,
    [authApi.reducerPath]: authApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [masterApi.reducerPath]: masterApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [emailTemplatesApi.reducerPath]: emailTemplatesApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [filterAPI.reducerPath]: filterAPI.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [clubApi.reducerPath]: clubApi.reducer,
    [brandApi.reducerPath]: brandApi.reducer,
    [managePromotionApi.reducerPath]: managePromotionApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [fourvenuesApi.reducerPath]: fourvenuesApi.reducer,
  });

/** ***************** 
@purpose : RTK Query middlwares
@Author : INIC
@return : array of middlewares
***************** */
export const getReducerMiddlewares = () => [
  authApi.middleware,
  profileApi.middleware,
  settingsApi.middleware,
  userApi.middleware,
  masterApi.middleware,
  roleApi.middleware,
  reportsApi.middleware,
  emailTemplatesApi.middleware,
  blogApi.middleware,
  filterAPI.middleware,
  supportApi.middleware,
  categoryApi.middleware,
  clubApi.middleware,
  brandApi.middleware,
  managePromotionApi.middleware,
  dashboardApi.middleware,
  fourvenuesApi.middleware,
];
